import { connect } from "react-redux";
import { State } from "../types";
import NextMeeting, { StateProps } from "../components/dashboard/NextMeeting";

const mapStateToProps = (state: State): StateProps => {
    const { lastMeetingId } = state;
    return {
        lastMeetingId,
    };
};

export default connect(mapStateToProps)(NextMeeting);
